import action from "../helpers/rest-client";
import {
  RegisterViewOutDto,
  GetMetricsOutDto,
  GetIncrementOutDto,
  GetTimeSeriesOutDto,
  GetViewsBySubscriberOutDto,
} from "../types/post-views.dto";

export class ErrorPostViews extends Error { }

class PostViews {
  /**
   * Registrar una nueva vista de un post
   */
  public async registerView(payload: RegisterViewOutDto) {
    return action
      .Post({
        url: `/api/post-views/register`,
        body: payload,
      })
      .then((response) => {
        return { response, error: undefined };
      })
      .catch((error) => {
        return { error, response: undefined };
      });
  }

  /**
   * Obtener métricas agregadas de un post
   */
  public async getMetrics(payload: GetMetricsOutDto) {
    return action
      .Get({
        url: `/api/post-views/metrics/${payload.postId}`,
      })
      .then((response) => {
        return { response, error: undefined };
      })
      .catch((error) => {
        return { error, response: undefined };
      });
  }

  /**
   * Obtener incremento de vistas mes a mes
   */
  public async getIncrement(payload: GetIncrementOutDto) {
    const params = new URLSearchParams();
    if (payload.current_month) params.append('current_month', payload.current_month);
    if (payload.previous_month) params.append('previous_month', payload.previous_month);

    const queryString = params.toString();
    const url = `/api/post-views/increment/${payload.postId}${queryString ? `?${queryString}` : ''}`;

    return action
      .Get({ url })
      .then((response) => {
        return { response, error: undefined };
      })
      .catch((error) => {
        return { error, response: undefined };
      });
  }

  /**
   * Obtener serie temporal de vistas
   */
  public async getTimeSeries(payload: GetTimeSeriesOutDto) {
    const params = new URLSearchParams();
    if (payload.start_date) params.append('start_date', payload.start_date);
    if (payload.end_date) params.append('end_date', payload.end_date);
    if (payload.granularity) params.append('granularity', payload.granularity);

    const queryString = params.toString();
    const url = `/api/post-views/time-series/${payload.postId}${queryString ? `?${queryString}` : ''}`;

    return action
      .Get({ url })
      .then((response) => {
        return { response, error: undefined };
      })
      .catch((error) => {
        return { error, response: undefined };
      });
  }

  /**
   * Obtener vistas de un subscriber específico
   */
  public async getViewsBySubscriber(payload: GetViewsBySubscriberOutDto) {
    const params = new URLSearchParams();
    if (payload.start_date) params.append('start_date', payload.start_date);
    if (payload.end_date) params.append('end_date', payload.end_date);
    if (payload.post_id) params.append('post_id', payload.post_id.toString());

    const queryString = params.toString();
    const url = `/api/post-views/by-subscriber/${payload.subscriberId}${queryString ? `?${queryString}` : ''}`;

    return action
      .Get({ url })
      .then((response) => {
        return { response, error: undefined };
      })
      .catch((error) => {
        return { error, response: undefined };
      });
  }
}

const postViews = new PostViews();
export default postViews;

